import { message } from "antd";
import API_ROUTES from "app/constants/routes/api";
import { getItem } from "app/utils/session";

import {
    addBrandMiddleware,
    addBrandBegin,
    addBrandFail,
    getBrandMiddleware,
    getBrandBegin,
    getBrandFail,
    addProductSeriesBegin,
    addProductSeriesMiddleware,
    addProductSeriesFail,
    getProductSeriesBegin,
    getProductSeriesMiddleware,
    getProductSeriesFail,
    addModelBegin,
    addModelMiddleware,
    addModelFail,
    getModelBegin,
    getModelMiddleware,
    getModelFail,
    editBrandSuccessAction,
    editProductSeries,
    editModelSuccess,
    setSearchBrandProductModalData,
    getProductSeries,
    getBrand,
    getModel,
    setBrandProductModalData
} from "./action";
import {
    ADD_BRAND_SUCCESS,
    GET_BRAND_PAYLOAD,
    ADD_PRODUCT_SERIES_PAYLOAD,
    GET_PRODUCT_SERIES_PAYLOAD,
    ADD_MODEL_PAYLOAD,
    GET_MODEL_PAYLOAD,
    EDIT_BRAND,
    EDIT_PRODUCT_SERIES_PAYLOAD,
    EDIT_MODEL_PAYLOAD,
    GET_BRAND_PRODUCT_MODEL,
    SEARCH_BRAND_PRODUCT_MODEL,
} from "./types";
import { Service } from "app/config/service";
import { setActionItem, setNotificationMessage } from "../home/action";
import { toLower } from "app/utils/javascript";

const { createLogic } = require("redux-logic");

const addBrandLogic = createLogic({
    type: ADD_BRAND_SUCCESS,
    latest: true,
    process({ action }, dispatch, done) {
        dispatch(addBrandBegin());
        const formData = new FormData();
        const {
            name,
            shortDescription,
            longDescription,
            profilePic,
            isTool
        } = action.payload;

        formData.append("name", name);
        formData.append("shortDescription", shortDescription);
        formData.append("longDescription", longDescription);
        formData.append("image", profilePic);
        const token = getItem("token");
        formData.append("authToken", token ? token : "");
        const apiUrl = isTool ? API_ROUTES.ADD_TOOL : API_ROUTES.ADD_BRAND
        Service({
            method: "post",
            url: apiUrl,
            data: formData,
            headers: { "Content-Type": "multipart/form-data" },
        })
            .then((res) => {
                dispatch(addBrandMiddleware(res));
                dispatch(setActionItem("CYLINDER", "VIEW"));
                dispatch(setNotificationMessage({ type: "success", message: "brandCreatedSuccessfully" }));
                done();
            })
            .catch((err) => {
                dispatch(addBrandFail(err));
                dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
                done();
            });
    },
});


const editBrandLogic = createLogic({
    type: EDIT_BRAND,
    latest: true,
    process({ action }, dispatch, done) {
        dispatch(addBrandBegin());
        const formData = new FormData();
        const {
            name,
            shortDescription,
            longDescription,
            profilePic,
            id,
            isTool
        } = action.payload;

        if (name) {
            formData.append("name", name);
        }
        if (shortDescription) {
            formData.append("shortDescription", shortDescription);
        }
        if (longDescription) {
            formData.append("longDescription", longDescription);
        }
        if (profilePic) {
            formData.append("image", profilePic);
        }
        formData.append("id", id);
        const token = getItem("token");
        formData.append("authToken", token ? token : "");
        const apiUrl = isTool ? API_ROUTES.UPDATE_TOOL : API_ROUTES.UPDATE_DEVICES
        Service({
            method: "post",
            url: apiUrl,
            data: formData,
            headers: { "Content-Type": "multipart/form-data" },
        }).then((res) => {
            if (action?.payload?.pageNo) {
                const payload = { type: "BRAND", isTool: isTool, pageNo: action?.payload?.pageNo }
                dispatch(getBrand(payload));
            } else {
                dispatch(editBrandSuccessAction(action.payload));
            }
            dispatch(setNotificationMessage({ type: "success", message: "brandUpdatedSuccessfully" }));
            done();
        }).catch((err) => {
            dispatch(addBrandFail(err));
            dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
            done();
        });
    },
});

const addProductSeriesLogic = createLogic({
    type: ADD_PRODUCT_SERIES_PAYLOAD,
    latest: true,
    process({ action }, dispatch, done) {
        dispatch(addProductSeriesBegin());
        const formData = new FormData();
        const {
            name,
            shortDescription,
            longDescription,
            profilePic,
            brandId,
            isTool
        } = action.payload;

        formData.append("name", name);
        formData.append("shortDescription", shortDescription);
        formData.append("longDescription", longDescription);
        formData.append("image", profilePic);
        formData.append("brandId", brandId);

        const token = getItem("token");
        formData.append("authToken", token ? token : "");
        let apiUrl = ""
        if (isTool) {
            apiUrl = API_ROUTES.ADD_TOOL
        } else {
            apiUrl = API_ROUTES.ADD_PRODUCT_SERIES
        }
        Service({
            method: "post",
            url: apiUrl,
            data: formData,
            headers: { "Content-Type": "multipart/form-data" },
        })
            .then((res) => {
                if (res.data.error === null) {
                    dispatch(setActionItem("CYLINDER", "VIEW"));
                    dispatch(setNotificationMessage({ type: "success", message: "productSeriesCreatedSuccessfully" }));
                    dispatch(addProductSeriesMiddleware(res));
                } else {
                    dispatch(addProductSeriesFail(res.data.error));
                }
                done();
            })
            .catch((err) => {
                dispatch(addProductSeriesFail(err));
                dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
                done();
            });
    },
});

const editProductSeriesLogic = createLogic({
    type: EDIT_PRODUCT_SERIES_PAYLOAD,
    latest: true,
    process({ action }, dispatch, done) {
        dispatch(addBrandBegin());
        const formData = new FormData();
        const {
            name,
            shortDescription,
            longDescription,
            profilePic,
            isTool,
            id
        } = action.payload;

        if (name) {
            formData.append("name", name);
        }
        if (shortDescription) {
            formData.append("shortDescription", shortDescription);
        }
        if (longDescription) {
            formData.append("longDescription", longDescription);
        }
        if (profilePic) {
            formData.append("image", profilePic);
        }
        formData.append("id", id);
        const token = getItem("token");
        formData.append("authToken", token ? token : "");
        const apiUrl = isTool ? API_ROUTES.UPDATE_TOOL : API_ROUTES.UPDATE_DEVICES
        Service({
            method: "post",
            url: apiUrl,
            data: formData,
            headers: { "Content-Type": "multipart/form-data" },
        }).then((res) => {
            if (action.payload?.parentId) {
                const payload = { type: "PRODUCT_SERIES", pageNo: action.payload?.pageNo, isTool: isTool, parentId: action.payload?.parentId }
                dispatch(getProductSeries(payload));
            } else {
                dispatch(editProductSeries(action.payload));
            }
            dispatch(setNotificationMessage({ type: "success", message: "productSeriesUpdateSuccessfully" }));
            done();
        }).catch((err) => {
            dispatch(addBrandFail(err));
            dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
            done();
        });
    },
});

const addModelLogic = createLogic({
    type: ADD_MODEL_PAYLOAD,
    latest: true,
    process({ action }, dispatch, done) {
        dispatch(addModelBegin());
        const formData = new FormData();
        const {
            name,
            shortDescription,
            longDescription,
            profilePic,
            brandId,
            productSeriesId,
            isTool
        } = action.payload;

        formData.append("name", name);
        formData.append("shortDescription", shortDescription);
        formData.append("longDescription", longDescription);
        formData.append("image", profilePic);
        formData.append("brandId", brandId);
        formData.append("productSeriesId", productSeriesId);

        const token = getItem("token");
        formData.append("authToken", token ? token : "");
        let apiUrl = ""
        if (isTool) {
            apiUrl = API_ROUTES.ADD_TOOL
        } else {
            apiUrl = API_ROUTES.ADD_MODEL
        }
        Service({
            method: "post",
            url: apiUrl,
            data: formData,
            headers: { "Content-Type": "multipart/form-data" },
        })
            .then((res) => {
                if (res.data.error === null) {
                    dispatch(setActionItem("CYLINDER", "VIEW"));
                    dispatch(setNotificationMessage({ type: "success", message: "modelCreatedSuccessfully" }));
                    dispatch(addModelMiddleware(res));
                } else {
                    dispatch(addModelFail(res.data.error));
                }
                done();
            })
            .catch((err) => {
                dispatch(addModelFail(err));
                dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
                done();
            });
    },
});

const editModelLogic = createLogic({
    type: EDIT_MODEL_PAYLOAD,
    latest: true,
    process({ action }, dispatch, done) {
        dispatch(addModelBegin());
        const formData = new FormData();
        const {
            name,
            shortDescription,
            longDescription,
            profilePic,
            isTool,
            id
        } = action.payload;

        if (name) {
            formData.append("name", name);
        }
        if (shortDescription) {
            formData.append("shortDescription", shortDescription);
        }
        if (longDescription) {
            formData.append("longDescription", longDescription);
        }
        if (profilePic) {
            formData.append("image", profilePic);
        }
        formData.append("id", id);
        const token = getItem("token");
        formData.append("authToken", token ? token : "");
        let apiUrl = ""
        if (isTool) {
            apiUrl = API_ROUTES.UPDATE_TOOL
        } else {
            apiUrl = API_ROUTES.UPDATE_DEVICES
        }
        Service({
            method: "post",
            url: apiUrl,
            data: formData,
            headers: { "Content-Type": "multipart/form-data" },
        }).then((res) => {
            if (res.data.error === null) {
                message.success("Model Update Successfully!");
                if (action.payload?.parentId) {
                    const payload = { type: "MODEL", pageNo: action.payload?.pageNo, isTool: isTool, parentId: action.payload?.parentId }
                    dispatch(getModel(payload));
                } else {
                    dispatch(editModelSuccess(action.payload));
                }
            } else {
                dispatch(addModelFail(res.data.error));
            }
            done();
        }).catch((err) => {
            dispatch(addModelFail(err));
            dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
            done();
        });
    },
});

const getBrandLogic = createLogic({
    type: GET_BRAND_PAYLOAD,
    latest: true,
    process({ action }, dispatch, done) {
        dispatch(getBrandBegin());
        const formData = new FormData();
        const {
            type,
            pageNo,
            isTool
        } = action.payload;
        formData.append("type", type);
        const token = getItem("token");
        formData.append("authToken", token ? token : "");
        const payload = {
            "authToken": `${token ? token : ""}`,
            "type": `${type}`
        }
        let apiUrl = ""
        if (isTool) {
            apiUrl = pageNo ? (`${API_ROUTES.GET_TOOL}${pageNo}`) : (`${API_ROUTES.GET_TOOL}1`)
        } else {
            apiUrl = pageNo ? (`${API_ROUTES.GET_BRAND}${pageNo}`) : (`${API_ROUTES.GET_BRAND}1`)
        }
        Service({
            method: "post",
            url: apiUrl,
            data: payload,
            headers: { "Content-Type": "application/json" },
        })
            .then((res) => {
                if (res.data.error === null) {
                    if (action?.payload?.all) {
                        dispatch(setBrandProductModalData({ type: toLower(type), payload: res.data.data }));
                    } else {
                        dispatch(getBrandMiddleware(res.data.data));
                    }
                } else {
                    dispatch(getBrandFail(res.data.error));
                }

                done();
            })
            .catch((err) => {
                dispatch(getBrandFail(err));
                dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
                done();
            });
    },
});

const getProductSeriesLogic = createLogic({
    type: GET_PRODUCT_SERIES_PAYLOAD,
    latest: true,
    process({ action }, dispatch, done) {
        dispatch(getProductSeriesBegin());
        const formData = new FormData();
        const {
            type,
            parentId,
            pageNo,
            isTool
        } = action.payload;
        formData.append("type", type);
        const token = getItem("token");
        formData.append("authToken", token ? token : "");
        const payload = {
            "authToken": `${token ? token : ""}`,
            "type": `${type}`,
            "parentId": `${(parentId * 1)}`
        }
        let apiUrl = ""
        if (isTool) {
            apiUrl = pageNo ? (`${API_ROUTES.GET_TOOL}${pageNo}`) : (`${API_ROUTES.GET_TOOL}1`)
        } else {
            apiUrl = pageNo ? (`${API_ROUTES.GET_PRODUCT_SERIES}${pageNo}`) : (`${API_ROUTES.GET_PRODUCT_SERIES}1`)
        }
        Service({
            method: "post",
            url: apiUrl,
            data: payload,
            headers: { "Content-Type": "application/json" },
        })
            .then((res) => {
                if (res.data.error === null) {
                    if (action?.payload?.all) {
                        dispatch(setBrandProductModalData({ type: 'product', payload: res.data.data }));
                    } else {
                        dispatch(getProductSeriesMiddleware(res.data.data));
                    }
                } else {
                    dispatch(getProductSeriesFail(res.data.error));
                }

                done();
            })
            .catch((err) => {
                dispatch(getProductSeriesFail(err));
                dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
                done();
            });
    },
});
const getModelLogic = createLogic({
    type: GET_MODEL_PAYLOAD,
    latest: true,
    process({ action }, dispatch, done) {
        dispatch(getModelBegin());
        const formData = new FormData();
        const {
            type,
            parentId,
            pageNo,
            isTool
        } = action.payload;
        formData.append("type", type);
        const token = getItem("token");
        formData.append("authToken", token ? token : "");
        const payload = {
            "authToken": `${token ? token : ""}`,
            "type": `${type}`,
            "parentId": `${(parentId * 1)}`
        }
        let apiUrl = ""
        if (isTool) {
            apiUrl = pageNo ? (`${API_ROUTES.GET_TOOL}${pageNo}`) : (`${API_ROUTES.GET_TOOL}1`)
        } else {
            apiUrl = pageNo ? (`${API_ROUTES.GET_MODEL}${pageNo}`) : (`${API_ROUTES.GET_MODEL}1`)
        }
        Service({
            method: "post",
            url: apiUrl,
            data: payload,
            headers: { "Content-Type": "application/json" },
        })
            .then((res) => {
                if (res.data.error === null) {
                    if (action.payload?.all) {
                        dispatch(setBrandProductModalData({ payload: res?.data?.data, type: "model" }))
                    } else {
                        dispatch(getModelMiddleware(res.data.data));
                    }
                } else {
                    dispatch(getModelFail(res.data.error));
                }

                done();
            })
            .catch((err) => {
                dispatch(getModelFail(err));
                dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
                done();
            });
    },
});

const getBrandProductModal = createLogic({
    type: GET_BRAND_PRODUCT_MODEL,
    latest: true,
    process({ action }, dispatch, done) {
        const authToken = getItem("token");
        let payload = action.payload?.payload;
        payload.authToken = authToken;
        Service({
            method: "post",
            url: API_ROUTES.GET_BRAND_MODEL(action.payload?.pageNo),
            data: payload,
        })
            .then((res) => {
                console.log(`res`, res)
            })
            .catch((err) => {
                dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
                done();
            });
    },
});

const searchBrandProductModal = createLogic({
    type: SEARCH_BRAND_PRODUCT_MODEL,
    latest: true,
    process({ action }, dispatch, done) {
        const authToken = getItem("token");
        let payload = action.payload?.payload;
        payload.authToken = authToken;
        Service({
            method: "post",
            url: API_ROUTES.SEARCH_BRAND_PRODUCT(action.payload?.pageNo),
            data: payload,
        })
            .then((res) => {
                dispatch(setSearchBrandProductModalData({ payload: res?.data?.data, type: action.payload?.type, pageNo: action.payload?.pageNo }))
            })
            .catch((err) => {
                dispatch(setNotificationMessage({ type: "error", message: "errorMsg" }));
                done();
            });
    },
});


export default [
    addBrandLogic,
    editBrandLogic,
    getBrandLogic,
    addProductSeriesLogic,
    getProductSeriesLogic,
    addModelLogic,
    getModelLogic,
    editProductSeriesLogic,
    editModelLogic,
    getBrandProductModal,
    searchBrandProductModal
];
